
// TODO from Nikola: this icon is not truly filled, but stroked instead. This component should be renamed at minimum.
export default {
  name: 'InfoFilledIcon',
  props: {
    stroke: {
      type: String,
      default: null,
    },
    // TODO from Nikola: this isn't used at all at the time of writing. And it likely does not work properly, so it should be removed if so.
    fill: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: '16',
    },
  },
  emits: ['back'],
  computed: {
    fillAndStrokeClass() {
      let res = '';
      // In order to trigger css animations we need to set the default stroke and fill here
      res += 'stroke-' + (this.stroke ? this.stroke : 'neutral-1');
      res += ' fill-' + (this.fill ? this.fill : 'neutral-13');

      return res;
    },
  },
};
